<style>
	.slider {
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: stretch;
		will-change: height, transform;
	}
</style>

<script lang="ts">
	import type { Writable } from "svelte/store";
	import { tweened } from "svelte/motion";
	import { onMount, tick, getContext } from "svelte";

	export let currentHeight: number = 0;
	export let oldHeight: number = 0;
	export let element: HTMLDivElement;
	export let elementOuter: HTMLDivElement;
	export let easing: (t: number) => number = (t: number) => t;

	const timing = getContext<Writable<Timing>>("timing");

	let applyHeight: string = "auto";
	let applyHeightMin: string = "auto";
	let mounted: boolean = false;
	let tweenedVariableY: ReturnType<typeof tweened<number>>;
	let width: number = 0;
	let recordDuration = 500;
	let isAnimating = false;

	$: {
		if (isAnimating === false) {
			applyHeight = `auto`;
			applyHeightMin = `initial`;
		} else {
			applyHeightMin = `initial`;
			applyHeight = $tweenedVariableY
				? `${$tweenedVariableY}px`
				: `${currentHeight}px`;
		}
	}
	$: changeHeight(oldHeight, currentHeight);
	$: if (timing) recordDuration = $timing.duration;

	const changeHeight = async (oldHeight: number, height: number) => {
		if (height === 0) return;
		if (oldHeight === 0) return;
		const duration = Math.round(
			(1 - $timing.in - $timing.out) * recordDuration
		);
		tweenedVariableY = tweened(oldHeight, {
			delay: $timing.out * recordDuration,
			duration: duration,
			easing: easing
		});
		await tick();
		isAnimating = true;
		tweenedVariableY.set(height).then(() => {
			isAnimating = false;
		});
	};

	onMount(() => {
		mounted = true;
	});
</script>

<div bind:this="{elementOuter}" style="height: {applyHeight}">
	<div
		bind:this="{element}"
		bind:clientWidth="{width}"
		style="height: {applyHeight}; min-height: {applyHeightMin}"
		class="slider {$$props.class || ''}">
		<slot />
	</div>
</div>
